import actions from 'redux/actions'


const get = (tokenName) => actions.models.requestTokens.get(tokenName)

const update = (tokenName, value) => {
  actions.models.requestTokens.update({
    [tokenName]: value,
  })
}


export default {
  get,
  update,
}
